import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { VideoCallEvent } from '../models/video-call-event';

export const VIDEO_CALL_PROVIDER = new InjectionToken<VideoCallProvider>('VideoCallProvider');

export interface VideoCallProvider {
    getVideoCallEvents(): Observable<VideoCallEvent>;

    emitVideoCallEvent(event: VideoCallEvent): void;

    initializeVideoCall(url: string, token: string, userName?: string): Promise<void>;

    hungUpVideoCall(): Promise<void>;

    turnOnMicrophone(): void;

    turnOffMicrophone(): void;

    hasVideoCallInstance(): boolean;
}
